import { trackLink, trackView } from "~/helpers/trackings";
import { formatValueTrackings, parseTitleHero } from "./helpers";
import { STORE_CODE } from "./constants";

export const pageView = async () => {
    trackView({
        page_name: `${STORE_CODE}:home`,
        page_category_1: STORE_CODE,
        page_category_2: 'home',
        page_category_10: 'home',
        page_content_status: 'free' 
    });
}

export const homeHeroLinkTrack = async (buttonText, content) => {
    trackLink({
        event_name: `${STORE_CODE}:home:banner`,
        event_type: `${parseTitleHero(content)}:${formatValueTrackings(buttonText)}`
    }, null, `HB @CLICK: ${parseTitleHero(content)}:${formatValueTrackings(buttonText)}`)
}

export const proHighlightLinkTrack = async (val) => {
    trackLink({
        event_name: `${STORE_CODE}:home:le-soluzioni-pro`,
        event_type: `${formatValueTrackings(val)}`
    }, null, `PHL @CLICK: ${formatValueTrackings(val)}`)
}

export const proHighlightProductTrack = async (val) => {
    trackLink({
        event_name: `${STORE_CODE}:home:card-prodotto`,
        event_type: `${formatValueTrackings(val)}`
    }, null, `PHP @CLICK: ${formatValueTrackings(val)}`)
}

export const proHighlightButtonTrack = async () => {
    trackLink({
        event_name: `${STORE_CODE}:home:pulsante-vai-ai-prodotti`,
        event_type: `vai-ai-prodotti`
    }, null, `PHB @CLICK: vai-ai-prodotti`)
}

export const highlightCardCategoryTrack = async (val, callback) => {
    trackLink({
        event_name: `${STORE_CODE}:home:card-categoria`,
        event_type: `${formatValueTrackings(val)}`
    }, callback, `HCC @CLICK: ${formatValueTrackings(val)}`)
}

export const promoBannerButtonTrack = async (productName) => {
    trackLink({
        event_name: `${STORE_CODE}:home:scopri-di-piu-prodotto`,
        event_type: `${formatValueTrackings(productName)}:scopri-di-più` // Scopri di più è hardcoded perchè statico, se in futuro cambia salta il track.
    }, null, `PBB @CLICK: ${formatValueTrackings(productName)}:scopri-di-più`)
}

export const areaTematicaButtonTrack = async (val) => {
    trackLink({
        event_name: `${STORE_CODE}:home:vai-ai-prodotti-aree-tematiche`,
        event_type: `${formatValueTrackings(val)}:vai-ai-prodotti` // Vai ai prodotti è hardcoded perchè statico, se in futuro cambia salta il track.
    }, null, `ATB @CLICK: ${formatValueTrackings(val)}:vai-ai-prodotti`)
}

export const areaTematicaGammaTrack = async (categoryName, subcategoryName) => {
    trackLink({
        event_name: `${STORE_CODE}:home:gamma-aree-tematiche`,
        event_type: `${formatValueTrackings(categoryName)}:${formatValueTrackings(subcategoryName)}` // Vai ai prodotti è hardcoded perchè statico, se in futuro cambia salta il track.
    }, null, `ATG @CLICK: ${formatValueTrackings(categoryName)}:${formatValueTrackings(subcategoryName)}`)
}


export const bestSellerCardTrack = async (product, callback) => {
    trackLink({
        event_name: `${STORE_CODE}:home:best-seller`,
        event_type: `${formatValueTrackings(product.name)}`
    }, callback, `BSC @CLICK: ${formatValueTrackings(product.name)}`)
}

export const bestSellerNavTrack = async (val) => {
    trackLink({
        event_name: `${STORE_CODE}:home:navigazione:best-seller`,
        event_type: `${formatValueTrackings(val)}`
    }, null, `BSN @CLICK: ${formatValueTrackings(val)}`)
}